/**
 * NCAA Football Sport Configuration
 *
 * Mirrors the NFL config's positions/prop categories (college football uses
 * the same stat surface via The Odds API). Teams intentionally empty — 130+
 * FBS programs are resolved from event data, not a static map.
 */

import type { SportConfig } from './types';
import { nflConfig } from './nfl';

export const ncaafConfig: SportConfig = {
  sport: 'NCAA_FOOTBALL',
  label: 'NCAA Football',
  shortLabel: 'NCAAF',

  oddsApiSportKey: 'americanfootball_ncaaf',

  drawLabel: 'Tie',
  espnPath: { sport: 'football', league: 'college-football' },

  positions: nflConfig.positions,
  propCategories: nflConfig.propCategories,
  defaultRosterSlots: nflConfig.defaultRosterSlots,
  defaultRosterSize: nflConfig.defaultRosterSize,
  defaultMaxProps: nflConfig.defaultMaxProps,

  identity: {
    color: '#8C6D3F',
    metal: 'Brass',
    icon: 'GraduationCap',
  },

  teams: {},
};
